import { get, post, del } from '../utils/request';

// 定义品牌列表接口入参类型
interface BrandParams {
  product_category_id: string;
  product_base_attribute_id?: string;
}



// 获取商品分类列表
// product_category_type_id 1商品 2服务商品
export const getProductCategoryAllList = (product_category_type_id=1) => {
  return get<any>('/web/get_product_category_tree',{product_category_type_id});
};

// 获取商品品牌列表
export const getProductBrandAllList = (query:any) => {
  return get<any>('/web/get_product_category_brand_all_list',query);
};


// 获取首页推荐分类
export const getProductCategoryShowList = () => {
  return get<any>('/web/get_product_category_show_list');
};


// 获取spu列表
export const getProductSpuAllList = (query:any) => {
  return get<any>('/product/get_product_category_brand_spu_all_list',query);
};


// 获取option列表
//入参product_category_id product_category_brand_id
export const getProductOptionAllList = (query:any) => {
  return get<any>('/product/get_product_category_base_attribute_option_all_list',query);
};


// 获取产品列表
export const getProductList = (query:any) => {
  return get<any>('/web/get_product_page_list',query);
};

// 获取产品列表
export const getProductListStore = (query:any) => {
  return get<any>('/product/get_product_page_list',query);
};

// 获取产品详情
export const getProductDetail = (query:any) => {
  return get<any>('/web/get_product_by_id',query);
};


// 保存产品
export const saveProduct = (params:any) => {
  return post<any>('/product/save_product',params);
};

// 删除产品
export const deleteProduct = (productIds: string | string[]) => {
  const productIdList = Array.isArray(productIds) ? productIds : [productIds];
  return post<any>('/product/save_delete_product', { 
    product_id_list: productIdList,
    is_delete: true 
  });
};

// 导出所有产品数据
export const exportAllProducts = (query: any) => {
  return get<any>('/product/export_all_products', query);
};


// 记录浏览记录
export const saveUserBrowserRecord = (params: any) => {
  return post<any>('/product/save_user_browser_record', params);
};

// 获取浏览记录列表
export const getUserBrowserRecordList = (query:any) => {
  return get<any>('/product/get_user_browser_record_list',query);
};


// 收藏
export const saveUserCollect = (params: any) => {
  return post<any>('/product/save_user_collection', params);
};

// 获取收藏列表
export const getUserCollectList = (query:any) => {
  return get<any>('/product/get_user_collection_list',query);
};

// 获取是否收藏
export const getIsCollectionProduct = (query:any) => {
  return get<any>('/product/get_is_collection_product',query);
};

// 保存商品模板
export const productTemplateSave = (params: any) => {
  return post<any>('/user/save_user_product_template',params);
};

// 获取商品模板
export const getProductTemplateList = (query: any) => {
  
  return get<any>('/user/get_user_product_templates',query);
};

// // 根据最后一级分类id获取品牌列表
// export const getProductBrandListByCategoryId = (params: BrandParams) => {
//   return get<any>('/product/get_product_category_base_attribute_all_list', params);
// };
// 获取创建的直播
export const liveRoomGetLiveRoomPageList = (query: any) => {
  return get<any>('/live_room/get_live_room_page_list',query);
};
// 创建直播
export const liveRoomSaveScheduleLiveRoom = (params: any) => {
  return post<any>('/live_room/save_schedule_live_room',params);
};
// 删除历史购买记录
export const deleteHistoryRecord = (id: string) => {
  return del<any>(`/user/delete_vip_user/${id}`);
}
